import Tooltip from "@kea-mod/common/tooltip";
import { useTranslation } from "react-i18next";
import type { Exercise } from "../../../types/Exercise";

type Props = {
  activeExercise: Exercise;
  h: Function;
};

export const FeedForwardThresholdField = (props: Props) => {
  const { t } = useTranslation();

  const onChange = (event: any) => {
    props.h(event);
  };

  return (
    <div className="field">
      <label className="label" htmlFor="feedForward_threshold">
        {t("feedForward_threshold")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("feedForward_threshold_tooltip")}
        ></Tooltip>
      </label>
      <input
        type="text"
        className="input"
        id="feedForward_threshold"
        name="feedForward_threshold"
        value={props.activeExercise.feedForward_threshold}
        onChange={onChange}
      />
    </div>
  );
};
